/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { db } from "~/db/db";

const useGov = ({ clienteId, filters }) => {
  const [govs, setGovs] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchGovs = async () => {
      if (filters.produtoId) setGovs([]);
      else {
        setLoading(true);
        const idCliente = parseInt(clienteId);
        let query = db.govs.where("clienteId").equals(idCliente);

        if (filters.grupoMaterialId) {
          query = query.filter(
            (gov) =>
              (filters.grupoMaterialId ? gov.grupoMaterialId === filters.grupoMaterialId : true) &&
              (filters.produtoId ? gov.produtoId === filters.produtoId : true)
          );
        }
        const result = [];
        await query.each((item) => result.push(item));

        const sortedResults = result
          .map((gov) => ({
            ...gov,
            dataTimestamp: new Date(gov.data),
          }))
          .sort((a, b) => a.dataTimestamp - b.dataTimestamp);

        setGovs(sortedResults);
        setLoading(false);
      }
    };

    fetchGovs();
  }, [clienteId, filters.grupoMaterialId, filters.produtoId]);

  return {
    govs,
    loading,
  };
};

export default useGov;
